import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Search, X } from 'lucide-react';
import './SearchInput.css';

export function SearchInput({
  value,
  onChange,
  onSearch,
  placeholder = 'Поиск...',
  debounce = 300,
  className = '',
  ...props
}) {
  const [internal, setInternal] = useState(value || '');
  const timerRef = useRef(null);

  useEffect(() => {
    if (value !== undefined) setInternal(value);
  }, [value]);

  const handleChange = useCallback((e) => {
    const v = e.target.value;
    setInternal(v);
    if (onChange) onChange(e);
    if (onSearch) {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => onSearch(v), debounce);
    }
  }, [onChange, onSearch, debounce]);

  const handleClear = useCallback(() => {
    setInternal('');
    if (onChange) onChange({ target: { value: '' } });
    if (onSearch) onSearch('');
  }, [onChange, onSearch]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <div className={`ui-search-input ${className}`}>
      <Search size={16} className="ui-search-input__icon" />
      <input
        className="ui-search-input__field"
        type="text"
        value={internal}
        onChange={handleChange}
        placeholder={placeholder}
        {...props}
      />
      {internal && (
        <button className="ui-search-input__clear" onClick={handleClear} type="button" aria-label="Очистить">
          <X size={14} />
        </button>
      )}
    </div>
  );
}
